import React, { useMemo, useRef, useState } from "react";
import "./Header.css";
import { reactIcons } from "../../icons/reactIcons";
import { useClickOutside } from "../../utils/OutsideClick";
import LogoutModal from "../../pages/auth/logout/LogoutModal";
import { UserData } from "../../routes/AppRoutes";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { useLocation, useNavigate } from "react-router-dom";

interface HeaderProps {
  setIsAuthenticated: (data: UserData | null) => void;
  // title: string;
  // subtitle?: string;
  // userName: string;
  // userRole: string;
}

const Header: React.FC<HeaderProps> = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const location = useLocation();
  let { featureName } = useSelector((state: RootState) => state.AuthCard);
  const user = JSON.parse(
    localStorage.getItem("odessa_user_details") || "null",
  );

  const userDetails =
    useSelector((state: RootState) => state.Auth.token_details) || user;
  const logoutMenuRef = useRef<HTMLDivElement | null>(null);

  //using the following state to render the menuItems
  const [logoutMenuStatus, setLogoutMenuStatus] = useState(false);

  //using the following state to handle the logout
  const [logoutModalStatus, setLogoutModalStatus] = useState(false);

  useClickOutside(logoutMenuRef, () => setLogoutMenuStatus(false));

  const handleLogoutStatus = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setLogoutMenuStatus(false);
    setLogoutModalStatus(true);
  };

  let profileName = useMemo(() => {
    const firstInitial = userDetails?.firstName?.charAt(0) ?? "";
    const lastInitial = userDetails?.lastName?.charAt(0) ?? "";

    return `${firstInitial} ${lastInitial}`.toUpperCase();
  }, []);

  const handleRedirectHome = () => {
    navigate("/home");
  };

  let path = location.pathname;

  return (
    <div className="header-container">
      <div className="header-left">
        <h1 className="header-title">
          {location?.pathname === "/home"
            ? "Home"
            : featureName === "super_admin"
              ? "Super Admin"
              : featureName === "oc_all_in"
                ? "OC All-In"
                : featureName === "plc"
                  ? "PLC"
                  : ""}
        </h1>
        {path?.split("/")?.[1] === "oc-all-in" ? (
          <span className="header-subtitle">(Employee Reward Program)</span>
        ) : (
          ""
        )}
      </div>

      <div
        className="header-right"
        onClick={() => setLogoutMenuStatus(true)}
        ref={logoutMenuRef}
      >
        <div className="avatar-wrapper">
          <p>{profileName}</p>
          {/* <img src="https://via.placeholder.com/40" alt="User Avatar" /> */}
        </div>

        <div className="user-info">
          <span className="user-name">{`${userDetails?.firstName} ${userDetails?.lastName}`}</span>
          <span className="user-role">Admin</span>
        </div>

        <div className="dropdown-btn">
          <reactIcons.dropdownDownArrow />
        </div>
        {logoutMenuStatus && (
          <div className="logout-wrapper" onClick={handleLogoutStatus}>
            <div className="logout-menu" onClick={handleRedirectHome}>
              <reactIcons.home />
              <p>Home</p>
            </div>
            <div className="logout-menu">
              <reactIcons.logout />
              <p>Logout</p>
            </div>
          </div>
        )}
      </div>
      {logoutModalStatus && (
        <LogoutModal
          isOpen={logoutModalStatus}
          setIsAuthenticated={setIsAuthenticated}
          onCancel={() => setLogoutModalStatus(false)}
        />
      )}
    </div>
  );
};

export default Header;
